import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.page.html',
  styleUrls: ['./contact-us.page.scss'],
})
export class ContactUsPage implements OnInit {
  contactForm: FormGroup;
  constructor(private formBuilder:FormBuilder,private server:UserApiService,private globals:GlobalVariable) { }

  ngOnInit() {
    this.setupForm()
  }
  get form() {
    return this.contactForm.controls
  }
setupForm() {
  this.contactForm = this.formBuilder.group({
    email: ['', [Validators.email, Validators.required]],
    name: ['', [Validators.minLength(2), Validators.required]],
    subject: [''],
    message: ['', [Validators.minLength(2), Validators.required]],
  });
}
onSubmit(){
  console.log(this.contactForm.value);
  if(this.contactForm.valid){
    this.globals.loader();
    this.server.submitContactMessage(this.contactForm.value).subscribe(res=>{
      console.log(res);
      this.globals.dismiss();
      this.globals.presentToast('Your Message has been submitted, You will be contacted soon. Thank you');
      this.contactForm.reset();

    },err=>{
      this.globals.dismiss();

      this.globals.presentToast('Network Error');
    })

  }

}
}
